import { Switch as NextSwitch } from '@nextui-org/react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: fit-content;
  align-items: center;
  .nextui-switch--checked {
    background-color: ${({ theme }) => theme.colors.primary.c700};
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary.c700};
    }
    &:active {
      background-color: ${({ theme }) => theme.colors.primary.c700};
    }
    &:hover:not(:active) {
      background-color: ${({ theme }) => theme.colors.primary.c700};
    }
  }
  .nextui-switch--unchecked {
    background-color: ${({ theme }) => theme.colors.neutrals.c300};
  }
`;

export const StyledSwitch = styled(NextSwitch)`
  padding: 0;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.neutrals.c300};
  font-size: ${({ theme }) => theme.fontSize.s};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  margin: auto 0.5rem auto auto;
`;
